module.exports = __webpack_public_path__ + "static/media/ambient_temp.7e2c1ab5.png";